import { DeleteOutlined } from '@ant-design/icons';
import { BasketballLeagueDbbTeam } from '@hefe/models';
import { BasketballLeaguesSlice, BasketballTeamsSlice } from '@hefe/store';
import { Button, Col, Row, Select, Typography } from 'antd';
import { t } from '@hefe/i18n';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';

export default function AddLeagueAssistentTeamSelection() {
  const dispatch = useAppDispatch();

  const [loading, setLoading] = useState(false);

  const leagueAssistent = useSelector(
    BasketballLeaguesSlice.basketballLeagueAssistentSelector
  );

  const clubTeamsSelect = useSelector(
    BasketballTeamsSlice.basketballTeamsSelectWithoutPendingSelector
  );

  useEffect(() => {
    fetchLeagueTeams();
    fetchClubTeams();
  }, []);

  const fetchClubTeams = () => {
    dispatch(
      BasketballTeamsSlice.fetchBasketballTeamsSelect({
        cacheDuration: 5 * 60 * 1000,
      })
    );
  };

  const fetchLeagueTeams = () => {
    const selectedLeague = leagueAssistent.selectedLeague;
    if (selectedLeague) {
      setLoading(true);
      dispatch(
        BasketballLeaguesSlice.fetchDbbBasketballLeagueTeams(
          selectedLeague.ligaId
        )
      )
        .unwrap()
        .finally(() => setLoading(false));
    }
  };

  const onClubTeamChange = (index: number, team: BasketballLeagueDbbTeam) => {
    dispatch(
      BasketballLeaguesSlice.basketballLeaguesActions.setSelectedTeamClubTeamId(
        {
          index,
          teamId: parseInt(team.value),
        }
      )
    );
  };

  const onLeagueTeamChange = (index: number, team: BasketballLeagueDbbTeam) => {
    dispatch(
      BasketballLeaguesSlice.basketballLeaguesActions.setSelectedTeamSeasonTeamId(
        {
          index,
          seasonTeamId: team.season_team_id || 0,
          name: team.label,
        }
      )
    );
  };

  const onSelectedTeamClick = (team: BasketballLeagueDbbTeam) => {
    dispatch(
      BasketballLeaguesSlice.basketballLeaguesActions.removeSelectedTeam(team)
    );
  };

  const renderTeamSelection = () => {
    const output = [];

    const leagueTeamsSelect = leagueAssistent.selectedLeague?.teams;

    for (const [index, team] of leagueAssistent.selectedTeams.entries()) {
      output.push(
        <Row key={team.team_id}>
          <Col xs={12}>
            <Typography.Text>
              {t('leagues.assistant.select_teams.club_team')}
            </Typography.Text>
            <Select
              style={{ width: '80%' }}
              options={clubTeamsSelect}
              value={team.team_id}
              disabled={loading}
              loading={loading}
              onChange={(value, option) =>
                onClubTeamChange(index, option as BasketballLeagueDbbTeam)
              }
            />
          </Col>
          <Col xs={12}>
            <Typography.Text>
              {t('leagues.assistant.select_teams.league_team')}
            </Typography.Text>
            <Select
              style={{ width: '80%' }}
              options={leagueTeamsSelect}
              value={team.value}
              disabled={loading}
              loading={loading}
              onChange={(value, option) =>
                onLeagueTeamChange(index, option as BasketballLeagueDbbTeam)
              }
            />
            <Button
              danger
              style={{ marginLeft: 8 }}
              onClick={() => onSelectedTeamClick(team)}
            >
              <DeleteOutlined />
            </Button>
          </Col>
        </Row>
      );
    }

    const lastSelectedTeam =
      leagueAssistent.selectedTeams.length > 0
        ? leagueAssistent.selectedTeams[
            leagueAssistent.selectedTeams.length - 1
          ]
        : undefined;
    if (
      !lastSelectedTeam ||
      (lastSelectedTeam.season_team_id && lastSelectedTeam.team_id)
    ) {
      output.push(
        <Row key="new">
          <Col xs={12}>
            <Typography.Text>
              {t('leagues.assistant.select_teams.club_team')}
            </Typography.Text>
            <Select
              style={{ width: '80%' }}
              options={clubTeamsSelect}
              value={undefined}
              disabled={loading}
              loading={loading}
              onChange={(value, option) =>
                onClubTeamChange(
                  leagueAssistent.selectedTeams.length,
                  option as BasketballLeagueDbbTeam
                )
              }
            />
          </Col>
          <Col xs={12}>
            <Typography.Text>
              {t('leagues.assistant.select_teams.league_team')}
            </Typography.Text>
            <Select
              style={{ width: '80%' }}
              options={leagueTeamsSelect}
              value={undefined}
              disabled={loading}
              loading={loading}
              onChange={(value, option) =>
                onLeagueTeamChange(
                  leagueAssistent.selectedTeams.length,
                  option as BasketballLeagueDbbTeam
                )
              }
            />
          </Col>
        </Row>
      );
    }

    return output;
  };

  return (
    <Row>
      <Col xs={24}>{renderTeamSelection()}</Col>
    </Row>
  );
}
